import { motion } from 'framer-motion';
import { FaTimes } from "react-icons/fa";
import { Box, IconButton, Modal, useMediaQuery } from "@mui/material";

export function ModalQuestion({ mostrarModalQuestion, cerrarModalQuestion, question }) {
  const isMobile = useMediaQuery('(max-width: 960px)');

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '90%' : '40%',
    height: 'auto',
    maxHeight: '85%',
    bgcolor: 'background.paper',
    boxShadow: 20,
    p: 4,
    borderRadius: '1.3rem',
    overflowY: 'auto',
  };


  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} >
      <Modal open={mostrarModalQuestion} onClose={cerrarModalQuestion}>
        <Box sx={style}>
          <IconButton onClick={cerrarModalQuestion} style={{ position: "absolute", top: "15px", right: "15px", cursor: "pointer", background: "none", border: "none", fontSize: "20px" }}>
            <FaTimes />
          </IconButton>
          <div className='pt-3'>
            <div className='font24 pt-4 pb-5' align='center'><strong>{question?.pregunta}</strong></div>
            <div className='contentText' align='justify'>{question?.respuesta}</div>
          </div>
        </Box>
      </Modal>
    </motion.div>
  )
}